import * as React from 'react';
import { SVGProps } from 'react';

const IcInfo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16 2c7.732 0 14 6.268 14 14s-6.268 14-14 14S2 23.732 2 16 8.268 2 16 2Zm0 2C9.373 4 4 9.373 4 16s5.373 12 12 12 12-5.373 12-12S22.627 4 16 4Zm1 7v14h-2V11h2Zm-1-5a2 2 0 1 1 0 4 2 2 0 0 1 0-4Z"
    />
  </svg>
);

export default IcInfo;
